import { FloorPlan } from './../../model/floorplan.model';
import { Action } from '@ngrx/store'

export const GET_FLOORPLAN = '[FLOORPLAN] GetFloorplan';
export const SET_FLOORPLAN = '[FLOORPLAN] SetFloorplan';
export const SEND_FLOORPLAN = '[FLOORPLAN] SendFloorplan';

export class GetFloorplan implements Action {
    readonly type = GET_FLOORPLAN

    constructor(public payload: string) {}
}

export class SetFloorplan implements Action {
    readonly type = SET_FLOORPLAN

    constructor(public payload: FloorPlan) {}
}

export class SendFloorplan implements Action {
    readonly type = SEND_FLOORPLAN

    constructor(public payload: FloorPlan) {}
}

export type Actions = GetFloorplan | SetFloorplan | SendFloorplan